import './JournalingContainer.scss'

import { Col, Container, Row } from 'react-bootstrap'
import JournalListGroup from '../JournalListGroup'
import Loading from '../../../../templates/Loading'

export default function JournalingContainer({
  isLoading,
  journalData,
  journalListHeading,
  isButtonLoading,
  activeIndex,
  children
}) {
  return (
    <Loading isLoaded={isLoading}>
      <Container className='journaling-create'>
        <Row className='center gap-2 gap-lg-4 gap-xl-5'>
          <Col className='mobile-hidden journaling-create-leftside'>
            <h3 className='mb-4'>{journalListHeading}</h3>
            <Loading
              isLoaded={!journalData.length || isButtonLoading}
              hasContainer={false}
            >
              <JournalListGroup
                journalData={journalData}
                activeJournalIndex={activeIndex}
              />
            </Loading>
          </Col>
          <Col>{children}</Col>
        </Row>
      </Container>
    </Loading>
  )
}
